import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';
import { Theme } from './types';

export async function getThemesRequest() {
  try {
    const response = await api().get('/themes');

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getThemesByMeetingIdRequest(
  meetingId: string,
  userId: string,
) {
  try {
    const response = await api().get(`/themes/meeting/${meetingId}`, {
      headers: {
        userId,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getThemeByIdRequest(themeId: string, userId: string) {
  try {
    const response = await api().get(`/themes/${themeId}`, {
      headers: {
        userId,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function createThemeRequest(
  theme: Partial<Theme>,
  companyId: string,
  userId: string,
) {
  try {
    if (theme.owner_user_id === null) {
      delete theme.owner_user_id;
    }

    const data = {
      ...theme,
    };

    const response = await api().post('/themes', data, {
      headers: {
        companyId,
        userId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function updateThemeRequest(
  theme: Partial<Theme>,
  themeId: string,
  userId: string,
  companyId: string,
) {
  try {
    if (theme.owner_user_id === null) {
      delete theme.owner_user_id;
    }

    const data = {
      ...theme,
    };

    const response = await api().patch(`/themes/${themeId}`, data, {
      headers: {
        companyId,
        userId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte');
    } else if (error.response.status === 401) {
      console.error('Não autorizado');
      return null;
    } else {
      toast.error(error.response.data.message);
    }

    console.error(error);
    return null;
  }
}

export async function updateOrderThemesRequest(
  themes_ids: string[],
  userId: string,
  companyId: string,
  meetingId: string,
) {
  try {
    const data = {
      themes_ids,
    };

    console.log(data, 'DATA UPDATE');

    const response = await api().patch(`/themes/order`, data, {
      headers: {
        userId,
        companyId,
        meetingId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function removeThemeRequest(
  themeId: string,
  companyId: string,
  userId: string,
) {
  try {
    const response = await api().patch(`/themes/remove/${themeId}`, {
      headers: {
        companyId,
        userId,
      },
    });

    return response.data;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function deleteThemeRequest(
  themeId: string,
  companyId: string,
  userId: string,
) {
  try {
    const response = await api().delete(`/themes/${themeId}`, {
      headers: {
        companyId,
        userId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}
